"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusResponse = void 0;
var StatusResponse;
(function (StatusResponse) {
    StatusResponse["Error"] = "ERROR";
    StatusResponse["InProgress"] = "IN_PROGRESS";
    StatusResponse["Success"] = "SUCCESS";
})(StatusResponse || (exports.StatusResponse = StatusResponse = {}));
